var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-select-box" },
    [
      _c(
        "selectize",
        {
          attrs: { value: "select" },
          model: {
            value: _vm.categoryValue,
            callback: function ($$v) {
              _vm.categoryValue = $$v
            },
            expression: "categoryValue",
          },
        },
        [
          _c(
            "option",
            { attrs: { selected: "" }, domProps: { value: _vm.baseValue } },
            [_vm._v("\n            " + _vm._s(_vm.baseTitle) + "\n        ")]
          ),
          _vm._v(" "),
          _vm._l(_vm.options, function (category) {
            return _c(
              "option",
              { key: category.id, domProps: { value: category.id } },
              [_vm._v("\n            " + _vm._s(category.name) + "\n        ")]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bi bi-arrow-down",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "#fff",
            viewBox: "0 0 16 16",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              d: "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }